module.exports = __webpack_public_path__ + "img/red_002.bdb09546.png";